import { reactive, watch } from "@vue/composition-api";
import { FormValidator } from "leatherman-js/models";

export default () => {
  const validator = (fieldSet, rules = {}, config = {}, translations = {}) => {
    const fields = Object.keys(fieldSet);

    const validation = reactive(new FormValidator(fieldSet, rules, config, translations));

    fields.forEach((fld) => {
      watch(
        () => fieldSet[fld],
        (newVal) => {
          validation.update(fld, newVal);
        }
      );
    });

    return validation;
  };

  return { validator };
};
